export default __webpack_public_path__ + "static/media/provas_inactive.4b56cd78.svg";